// Check Factor: % of peak boat speed kept at the lowest point of the stroke.
// points: [{ timestamp, speed }] at ~20 Hz; uses the last 60 samples (~3 s).
export function computeCheckFactor(points) {
  if (!points || points.length < 10) return null;
  const recent = points.slice(-60);
  const peaks = [];
  const valleys = [];
  for (let i = 1; i < recent.length - 1; i += 1) {
    const prev = recent[i - 1]?.speed || 0;
    const curr = recent[i]?.speed || 0;
    const next = recent[i + 1]?.speed || 0;
    if (curr > prev && curr > next && curr > 0.5) peaks.push(curr);
    if (curr < prev && curr < next && curr > 0) valleys.push(curr);
  }
  if (!peaks.length || !valleys.length) return null;
  const avgPeak = peaks.reduce((a, b) => a + b, 0) / peaks.length;
  const avgValley = valleys.reduce((a, b) => a + b, 0) / valleys.length;
  return { cf: avgPeak > 0 ? (avgValley / avgPeak) * 100 : 0, avgPeak, avgValley };
}
